import {EventEmitter} from 'angular2/core';

export interface IPaginationInstance {
	id?: string;
	itemsPerPage: number;
	currentPage: number;
	totalItems?: number;
}

export class PaginationService {

	static templateUrl: string;
	static template: string;

	public change: EventEmitter<string> = new EventEmitter();
	private instances: { [id: string]: IPaginationInstance } = {};
	private DEFAULT_ID = 'DEFAULT_PAGINATION_ID';

	get defaultId() { return this.DEFAULT_ID; }

	public getCurrentPage(id: string): number {
		if (this.instances[id]) {
			return this.instances[id].currentPage;
		}
	}

	public setCurrentPage(id: string, page: number) {
		if (this.instances[id]) {
			let instance = this.instances[id];
			let maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
			if (page <= maxPage && 1 <= page) {
				this.instances[id].currentPage = page;
				this.change.emit(id);
			}
		}
	}

	public register(instance: IPaginationInstance) {
		if (!instance.id) {
			instance.id = this.DEFAULT_ID;
		}

		if (!this.instances[instance.id]) {
			this.instances[instance.id] = instance;
			this.change.emit(instance.id);
		} else {
			let changed = this.updateInstance(instance);
			if (changed) {
				this.change.emit(instance.id);
			}
		}
	}

	public getInstance(id: string = this.DEFAULT_ID): IPaginationInstance {
		if (this.instances[id]) {
			return this.clone(this.instances[id]);
		}
	}

	public setTotalItems(id: string, totalItems: number) {
		if (this.instances[id] && 0 <= totalItems) {
			this.instances[id].totalItems = totalItems;
			this.change.emit(id);
		}
	}

	private updateInstance(instance: IPaginationInstance): boolean {
		let changed = false;
		for (let prop in this.instances[instance.id]) {
			if (instance[prop] !== this.instances[instance.id][prop]) {
				this.instances[instance.id][prop] = instance[prop];
				changed = true;
			}
		}
		return changed;
	}

	private clone(obj: any): any {
        var target = {};
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                target[i] = obj[i];
            }
        }
        return target;
    }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/pagination/pagination-service.ts
 **/